<div class="information">
    A new version is available. <br/>
    Please update.
    <hr class="default">
    <fluent-button style="height: 60px;" appearance="accent" (click)="openLink(config!.downloadUrl)"><div class="download-btn" >Download</div></fluent-button>
</div>